// deploy-pipelines-run-overrides (Wave 4, AC-10) — the branch label for one run's OWN row in
// run history/detail, so an override run stays distinguishable from a default run after the
// fact. `PipelineRunDto.BranchName` is null when the run has no built image yet (still Queued,
// orphaned, or predates this slice) — that is a defined, expected state, never a blank cell.
export const UNRESOLVED_RUN_BRANCH_LABEL = '—';

/**
 * @param {string|null|undefined} branchName  `PipelineRunDto.BranchName`.
 * @returns {string}  The branch name verbatim, or the defined placeholder — never blank,
 *                     never undefined.
 */
export const resolveRunBranchDisplay = (branchName) =>
	typeof branchName === 'string' && branchName.trim().length > 0 ? branchName : UNRESOLVED_RUN_BRANCH_LABEL;

export default resolveRunBranchDisplay;
